<template>
  <div>
    
    <div
      class="content"
      v-for="(item, index) in dataList"
      :key="index"
      @click="checked(item)"
    >
      <div class="right-sty">
        <div class="left-tit">{{ item.name }}</div>
        <div class="left-span">
          <div>
            <div v-for="(litm, index) in item.lottery" :key="index">
              <span>奖品{{ index + 1 }}：</span>
              <span>{{ litm.name }}</span>
              <span class="span-num">X{{ litm.acount }}</span>
            </div>
          </div>
          <div>{{ item.status == 1 ? "已结束" : "进行中" }}</div>
        </div>
        <div class="left-time">{{item.time}}开奖</div>
      </div>
    </div>
    <van-share-sheet
      v-model="showShare"
      :options="options"
      @select="onSelected"
    />
  </div>
</template>
<script>
import { Dialog } from "vant";
import URL from "@/api/api";
export default {
  data() {
    return {
      status:'',
      id: "",
      name:'',
      dataList: [
       
      ],
      showShare: false,
      options: [
      
        {
          name: "详情",
          icon: require(`./../assets/img/questionnaire.png`),
        },
        {
          name: "分享",
          icon: require(`./../assets/img/share.png`),
        },
      ],
    };
  },
   created(){this.fetchData()},
  mounted() {},
  methods: {
    checked(item) {
      this.status=item.status;
      this.name=item.name;
      this.id = item.id;
      if (item.id) {
        this.showShare = true;
      }
   
    },
    onSelected(option) {
      this.showShare = false;
      // this.$router.push("/lotteryDetails/details");
      if (option.name == "编辑") {
        this.$router.push({ path: "/newLottery/details", query: { id: this.id,type:'0'} });
      }
      if (option.name == "详情") {
        this.$router.push({ path: "/lotteryDetails/details", query: { id: this.id,status:this.status,name:this.name } });
      }
      if (option.name == "删除") {
        Dialog.confirm({
          title: "系统提示",
          message: "是否确认删除此选项？",
        })
          .then(() => {
            this.dataList.map((x) => {
              this.$fetchGet(URL.removebatchinfo.url,{batchid:this.id})
              if (this.id == x.id) {
                this.dataList.splice(0, 1);
              }
            });
          })
          .catch(() => {
            return false;
          });
      }
    },
    myCreated() {
      this.$router.push("/newLotteryTitle");
    },
    fetchData() {
      let data={
          openid:localStorage.getItem("openid")
        }
      this.$fetchGet(URL.getawardList.url, data).then((res) => {
         this.dataList = res.data.data.record;
      });
    },
  },
};
</script>
<style scoped>
.content {
  width: 95%;
  margin: 10px auto;
  padding: 10px;
  line-height: 35px;
  background: #fff;
  border-radius: 5px;
}
.left-tit {
  font-size: 0.35rem;
  font-weight: 600;
  font-family: serif;
}

.left-span {
  display: flex;
  justify-content: space-between;
  font-size: 16px;
}
.span-num {
  padding-left: 10px;
  color: #909399;
}
.left-time {
  font-size: 14px;
  color: #909399;
}
</style>